import React, { Component } from 'react';

export default class Contact extends Component {
    render() {
        return (
            <div id="map">
                <iframe
                    title="map"

                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2560.0862683229548!2d12.017349075802661!3d45.49409083144454!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x477ece80c4f6f39b%3A0xd913126573cd4a61!2sEDILPAGOTTO%20Srl!5e1!3m2!1sit!2sit!4v1718637520141!5m2!1sit!2sit"
                    width="80%"
                    height="450"
                    allowFullScreen=""
                    loading="lazy">
                </iframe >
            </div >
        );
    }
}
